import { ConfirmDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useLoanActionsStore } from '../hooks/useLoanActionsStore';

export const ApproveTitleInformationModal = observer(
  ({ open, handleClose }) => {
    const { loanActionsStore } = useLoanActionsStore();

    const confirm = () => {
      loanActionsStore.approveTitleInformation();
      handleClose();
    };

    return (
      <ConfirmDialog
        open={open}
        confirmButtonText={'Yes'}
        handleClose={handleClose}
        handleCancel={handleClose}
        handleConfirm={confirm}
        title={'Approve Title Information'}
        body={`Are you sure you want to approve the Title section docs?`}
      />
    );
  }
);
